import type { GuardianProfile } from '@/features/guardian/services/get-guardian';
import { STRINGS } from '@/constants/strings';
import Constants from 'expo-constants';

export function getGuardianName(profile?: GuardianProfile, fallback?: string | null) {
  return (
    [profile?.firstname, profile?.lastname].filter(Boolean).join(' ').trim() ||
    fallback ||
    STRINGS.guardianProfile.fallbackName
  );
}

export function getGuardianProfileVersionLabel(tablet: boolean) {
  const version = Constants.nativeAppVersion ?? Constants.expoConfig?.version ?? '—';
  const build = Constants.nativeBuildVersion ?? Constants.expoConfig?.ios?.buildNumber ?? null;
  const label = build ? `${version} (${build})` : version;
  return tablet
    ? STRINGS.guardianProfile.version.tablet(label)
    : STRINGS.guardianProfile.version.phone(label);
}
